import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { makeSearch } from 'shared/actions/search';
import { IFiltersUpdatedEventDetail } from 'shared/types/microfrontends';
import { TThunkDispatch } from 'shared/types/redux';

/**
 * Подписывается на событие из микрофронта на применение фильтров
 */
export const useFiltersUpdatedEvent = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  useEffect(() => {
    const onFiltersUpdated = ({ detail }: CustomEvent<IFiltersUpdatedEventDetail>) => {
      dispatch(makeSearch(detail));
    };

    addEventListener('filters:updated', onFiltersUpdated);

    return () => {
      removeEventListener('filters:updated', onFiltersUpdated);
    };
  }, [dispatch]);
};
